<template>
  <section
    :class="{
      'paid-section': true,
    }"
  >
    <HeroContent
      v-if="paidHeroContent"
      v-bind="paidHeroContent"
    />
    <div
      :class="{
        'container mx-auto mt-10': true,
      }"
    >
      <div :class="{ 'grid grid-cols-12': true, 'items-center': !enableStartupProgram }">
        <div
          :class="{
            'col-span-12 lg:col-span-6 lg:px-7': true,
            'order-2 lg:order-1': !enableStartupProgram,
          }"
        >
          <PortableText
            v-if="paidReferDiscovery?.content?.standardPortableText"
            :portable-data="paidReferDiscovery?.content?.standardPortableText"
          />
          <ReferAFriendBox
            v-if="paidReferDiscovery?.referAFriendBox"
            v-bind="paidReferDiscovery.referAFriendBox"
            lp-pathname="/en/accept-referral"
          />
        </div>
        <div
          :class="{
            'col-span-12 lg:col-span-6 lg:px-7': true,
            'order-1 lg:order-2': !enableStartupProgram,
          }"
        >
          <div v-if="enableStartupProgram">
            <PortableText
              v-if="paidReferAStartup?.content?.standardPortableText"
              :portable-data="paidReferAStartup?.content?.standardPortableText"
            />
            <ReferAFriendBox
              v-if="paidReferAStartup?.referAFriendBox"
              v-bind="paidReferAStartup.referAFriendBox"
              lp-pathname="/en/startups/apply"
            />
          </div>
          <div v-else>
            <PtcPicture
              v-if="paidRightColumnImage?.asset?._ref"
              :src="paidRightColumnImage.asset._ref"
              provider="sanity"
              :alt="'Collaboration in Onshape'"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import HeroContent from '~/components/Atmos/HeroContent/HeroContent.vue';
import PortableText from '~/components/Atmos/PortableText/PortableText.vue';
import ReferAFriendBox from './ReferAFriendBox.vue';
import PtcPicture from '~/components/Atmos/PtcPicture/PtcPicture.vue';
import type { PaidReferAFriend } from '~/sanity/types';
defineProps<PaidReferAFriend>();
</script>

<style></style>
